declare global {
	interface System {
		import(request: string): Promise<any>
	}
	var System: System
}
// import login from '../views/login.vue'
// import home from '../views/home/home.vue'
import main from '../views/main.vue'

export const locking = {
	path: '/locking',
	name: 'locking',
	component: () => System.import('../components/lockscreen/components/locking-page.vue')
};
export const loginRouter = {
	path: '/',
	name: 'login',
	meta: {
		title: 'LogIn'
	},
	component: () => System.import('../views/login.vue')
};
export const signinRouter = {
	path: '/signin',
	name: 'signin',
	meta: {
		title: 'SignIn'
	},
	component: () => System.import('../views/signin.vue')
};
export const forgetPwdRouter = {
	path: '/forgetPwd',
	name: 'forgetPwd',
	meta: {
		title: 'ForgetPwd'
	},
	component: () => System.import('../views/forgetPwd.vue')
};
export const otherRouters = {
	path: '/main',
	name: 'main',
	permission: '',
	meta: { title: '信息中心' },
	component: main,
	children: [
		// { path: 'home', meta: { title: '主页' }, name: 'home', component: () => System.import('../views/home/home.vue') },
		{ path: 'home', meta: { title: '主页' }, name: 'home', component: () => System.import('../views/home/home2.vue') },
		{ path: 'userProfile', meta: { title: '个人中心' }, name: 'userProfile', component: () => System.import('../views/userProfile/userProfile.vue') }
	]
};
export const appRouters = [
	// 个人中心模块
	{
		path: '/userCenter',
		name: 'userCenter(i)',
		permission: '',
		meta: { title: '个人中心' },
		icon: '',
		component: main,
		children: [
			{ path: 'attence/', permission: 'menu', meta: { title: '个人考勤记录' }, name: 'attence(i)', component: () => System.import('../views/iframe.vue') },
			{ path: 'mailpwd/', permission: 'menu', meta: { title: '企业邮箱密码' }, name: 'mailpwd(i)', component: () => System.import('../views/iframe.vue') },
			{ path: 'oapwd/', permission: 'menu', meta: { title: '修改共享服务器及OA密码' }, name: 'oapwd(i)', component: () => System.import('../views/iframe.vue') },
			{ path: 'auditingFile/', permission: 'menu', meta: { title: '文件审核' }, name: 'auditingFile', component: () => System.import('../views/documentation/auditingFile/auditingFile.vue') },
			{ path: 'kbrl/', permission: 'menu', meta: { title: '开标日历表' }, name: 'kbrl2(i)', component: () => System.import('../views/iframe.vue') },
			{ path: 'projectFlow/', permission: 'menu', meta: { title: '项目一览' }, name: 'projectFlow', component: () => System.import('../views/projectFlow/projectFlow.vue') },
			{ path: 'yjyl/', permission: 'menu', meta: { title: '业绩一览' }, name: 'yjyl(i)', component: () => System.import('../views/iframe.vue') },
			{ path: 'flowCenter/', permission: 'menu', meta: { title: '流程中心' }, name: 'flowCenter', component: () => System.import('../views/workflow/flowCenter.vue') },
		]
	},
	{
		path: '/training',
		name: 'training',
		permission: '',
		meta: { title: '培训管理' },
		icon: '',
		component: main,
		children: [
			{ path: 'pxgl/', permission: 'menu', meta: { title: '培训管理' }, name: 'pxgl(i)', component: () => System.import('../views/iframe.vue') }
		]
	},
	// 客户管理及立项
	{
		path: '/customerManage',
		name: 'customerManage',
		permission: '',
		meta: { title: '客户管理及立项' },
		icon: '',
		component: main,
		children: [
			{ path: 'npform/', permission: 'menu', meta: { title: '项目立项' }, name: 'npform', component: () => System.import('../views/workflow/nproject/npform2.vue') },
			{ path: 'tbgl/', permission: 'menu', meta: { title: '投标管理' }, name: 'tbgl(i)', component: () => System.import('../views/biddingManagement/biddingManagement.vue') },
			{ path: 'tbgl2/', permission: 'menu', meta: { title: '投标管理(到期)' }, name: 'biddingManagement2', component: () => System.import('../views/biddingManagement/biddingManagement.vue') },
			{ path: 'tbglJG/', permission: 'menu', meta: { title: '投标管理(军工)' }, name: 'biddingManagementJG', component: () => System.import('../views/biddingManagementJG/biddingManagement.vue') },
			// { path: 'pxgl/', permission: 'menu', meta: { title: '培训管理' }, name: 'pxgl(i)', component: () => System.import('../views/iframe.vue') },
			{ path: 'purchaserVisitList/', permission: 'menu', meta: { title: '采购人拜访记录', disabled: true, message: '该功能已关闭，请到4.0系统使用' }, name: 'purchaserVisitList', component: () => System.import('../views/purchaserInfo/purchaserVisitList.vue') },
			{ path: 'purchaserArchives/', permission: 'menu', meta: { title: '采购人档案', disabled: true, message: '该功能已关闭，请到4.0系统使用' }, name: 'purchaserArchives', component: () => System.import('../views/purchaserInfo/archives/purchaserArchives.vue') },
			{ path: 'purchaserInfoJG/', permission: 'menu', meta: { title: '采购人档案（军工）', disabled: true, message: '该功能已关闭，请到4.0系统使用' }, name: 'purchaserInfoJG', component: () => System.import('../views/purchaserInfoJG/archives/purchaserArchives.vue') },
		]
	},
	// 文件编制及挂网
	{
		path: '/documentation',
		name: 'documentation',
		permission: '',
		meta: { title: '文件编制及挂网' },
		icon: '',
		component: main,
		children: [
			{ path: 'npform2/', permission: 'menu', params: { workflowConfirm: true }, meta: { title: '项目立项确认' }, name: 'npform2', component: () => System.import('../views/workflow/nproject/npform2.vue') },
			{ path: 'documenting/', permission: 'menu', meta: { title: '编制及挂网', disabled: true, message: '该功能已关闭，请到4.0系统使用' }, name: 'documenting', component: () => System.import('../views/documentation/documenting.vue') },
			// { path: 'auditingFile/', permission: 'Pages.FileEdit.FileAudit', meta: { title: '文件审核' }, name: 'auditingFile', component: () => System.import('../views/documentation/auditingFile/auditingFile.vue') },
			// { path: 'articles/', permission: 'Pages.FileEdit', meta: { title: '招标公告挂网' }, name: 'articles', component: () => System.import('../views/articles/articles.vue') },
		]
	},
	// 供应商报名
	{
		path: '/nprojecttable',
		name: 'nprojecttable',
		permission: '',
		meta: { title: '供应商报名' },
		icon: '', // &#xe68a
		component: main,
		children: [
			{ path: 'examineEnroll/', permission: 'menu', meta: { title: '报名审核',disabled: true,  message: '该功能已关闭，请到4.0系统使用'}, name: 'examineEnroll', component: () => System.import('../views/nprojecttable/examineEnroll/examineEnroll.vue') },
		]
	},
	// 保证金
	{
		path: '/depositMenu',
		name: 'depositMenu',
		permission: '',
		meta: { title: '保证金' },
		icon: 'ionic', // &#xe68a
		component: main,
		children: [
			{ path: 'receiveDeposit/', permission: 'menu', meta: { title: '领取保证金',disabled: true,  message: '该功能已关闭，请到4.0系统使用' }, name: 'receiveDeposit', component: () => System.import('../views/deposit/deposit.vue') },
			{ path: 'depositProject/', permission: 'menu', meta: { title: '领取保证金（广发）',disabled: true,  message: '该功能已关闭，请到4.0系统使用' }, name: 'depositProject', component: () => System.import('../views/deposit/depositProject.vue') },
			// { path: 'depositBack/', permission: 'menu', meta: { title: '退保证金（广发）' }, name: 'depositBack', component: () => System.import('../views/depositBack/depositBack.vue') },
			// { path: 'depositBackExamine/', permission: 'menu', meta: { title: '退保证金审核' }, name: 'depositBackExamine', component: () => System.import('../views/depositBackExamine/depositBackExamine.vue') },
			{ path: 'depositDetail/', permission: 'menu', meta: { title: '保证金明细' }, name: 'depositDetail', component: () => System.import('../views/depositDetail/depositDetail.vue') },
			{ path: 'depositBackMenu/', permission: 'menu', meta: { title: '退保申请' }, name: 'depositBackFlow', component: () => System.import('../views/depositBackFlow/depositBackMenu.vue') },
			// { path: 'drawbackDeposit/', permission: 'Pages.Business.Margin', meta: { title: '退保证金' }, name: 'drawbackDeposit', component: () => System.import('../views/financialFlows/drawbackDeposit.vue') },
		]
	},
	// 电子评标及会务
	{
		path: '/dzpbhw',
		name: 'dzpbhw',
		permission: '',
		meta: { title: '电子评标及会务' },
		icon: '',
		component: main,
		children: [
			{ path: 'evaluationBid/', permission: 'menu', meta: { title: '电子评标' }, name: 'evaluationBid', component: () => System.import('../views/evaluationBid.vue') },
			{ path: 'kbrl/', permission: 'menu', meta: { title: '开标日历表' }, name: 'kbrl(i)', component: () => System.import('../views/iframe.vue') },
			{ path: 'room/', permission: 'menu', meta: { title: '会议室' }, name: 'roomindex', component: () => System.import('../views/room/roomIndex.vue') },
		]
	},
	// 项目管理
	{
		path: '/projectCenter',
		name: 'projectCenter',
		permission: '',
		meta: { title: '项目管理' },
		icon: '',
		component: main,
		children: [
			{ path: 'biddingConfirm/', permission: 'menu', meta: { title: '中标确认及打印' }, name: 'biddingConfirm', component: () => System.import('../views/projectCenter/biddingConfirm/biddingConfirm.vue') },
			{ path: 'serviceCManage/', permission: 'menu', meta: { title: '服务费到账管理' }, name: 'serviceCManage', component: () => System.import('../views/projectCenter/serviceManage.vue') },
			{ path: 'cancelProject/', permission: 'menu', meta: { title: '项目取消',disabled: true,  message: '该功能已关闭，请到4.0系统使用' }, name: 'cancelProject', component: () => System.import('../views/projectCenter/cancelProject/cancelProject.vue') },
			{ path: 'endingProject/', permission: 'menu', meta: { title: '历史项目',disabled: true,  message: '该功能已关闭，请到4.0系统使用' }, name: 'endingProject(i)', component: () => System.import('../views/iframe.vue') },
			{ path: 'documentSummary/', permission: 'menu', meta: { title: '文件汇总' }, name: 'documentSummary', component: () => System.import('../views/documentSummary/documentSummary.vue') },
			{ path: 'projectModify/', permission: 'menu', meta: { title: '项目编辑',disabled: true,  message: '该功能已关闭，请到4.0系统使用' }, name: 'projectModify', component: () => System.import('../views/projectCenter/projectModify/projectModify.vue') },
			{ path: 'MendProjectAudit/', permission: 'menu', meta: { title: '结项审核' }, name: 'MendProjectAudit', component: () => System.import('../views/projectCenter/MendProjectAudit.vue') },
			{ path: 'MendProjectAuditFq/', permission: 'menu', meta: { title: '结项审核(发起人)' }, name: 'MendProjectAuditFq', component: () => System.import('../views/iframe.vue') },
			{ path: 'MendProjectAuditJx/', permission: 'menu', meta: { title: '结项审核(结项人员)' }, name: 'MendProjectAuditJx', component: () => System.import('../views/iframe.vue') },
			{ path: 'MendProjectAuditJc/', permission: 'menu', meta: { title: '结项审核(监察人员)' }, name: 'MendProjectAuditJc', component: () => System.import('../views/iframe.vue') },
			{ path: 'argumentLink/', permission: 'menu', meta: { title: '论证质疑环节', disabled: true, message: '该功能已关闭，请到4.0系统使用' }, name: 'argumentLink', component: () => System.import('../views/argumentLink/argumentLink.vue') },
			{ path: 'complaintsRegistration/', permission: 'menu', meta: { title: '投诉质疑登记' }, name: 'complaintsRegistration', component: () => System.import('../views/complaintsRegistration/complaintsRegistration.vue') },
		]
	},
  // 档案管理
	{
		path: '/documentManage',
		permission: '',
		meta: { title: '档案管理' },
		icon: '',
		component: main,
		children: [
			{ path: 'documentManage/', permission: 'menu', meta: { title: '投标资料存档' }, name: 'documentManage', component: () => System.import('../views/documentManage/bidDocument.vue') },
			{ path: 'winbidContract/', permission: 'menu', meta: { title: '中标合同存档' }, name: 'winbidContract', component: () => System.import('../views/documentManage/winbidContract.vue') },
			{ path: 'winbidService/', permission: 'menu', meta: { title: '中标通知书及服务费发票' }, name: 'winbidService', component: () => System.import('../views/documentManage/winbidService.vue') },
			{ path: 'summaryData/', permission: 'menu', meta: { title: '汇总资料存档' }, name: 'summaryData', component: () => System.import('../views/documentSummary/documentSummary.vue') },
			{ path: 'docShifting/', permission: 'menu', meta: { title: '档案移交/调阅/归还' }, name: 'docShifting', component: () => System.import('../views/documentManage/docShifting.vue') },
		]
	},
	// 质控中心
	{
		path: '/zkzx',
		name: 'zkzx',
		permission: '',
		meta: { title: '质控中心' },
		icon: '',
		component: main,
		children: [
			{ path: 'articleExamine/', permission: 'menu', meta: { title: '公告审核' }, name: 'articleExamine', component: () => System.import('../views/projectCenter/articleExamine/articleExamine.vue') },
			{ path: 'endProjectAudit/', permission: 'menu', meta: { title: '项目结项审核' }, name: 'endProjectAudit', component: () => System.import('../views/endProjectAudit/endProjectAudit.vue') },
		]
	},
	// 财务管控
	{
		path: '/financeManager',
		name: 'financeManager',
		permission: '',
		meta: { title: '财务管控' },
		icon: '', // &#xe68a
		component: main,
		children: [
			{ path: 'ordersManagement/', permission: 'menu', meta: { title: '退保证金' }, name: 'ordersManagement', component: () => System.import('../views/ordersManagement/ordersManagement.vue') },
			{ path: 'ordersManagement2/', permission: 'menu', meta: { title: '退保证金(异常)' }, name: 'ordersManagement2', component: () => System.import('../views/ordersManagement/abnormalRefund.vue') },
			{ path: 'serviceCharge/', permission: 'menu', meta: { title: '线下服务费', disabled: true, message: '该功能已关闭，请到4.0系统使用' }, name: 'serviceCharge', component: () => System.import('../views/serviceCharge/serviceCharge.vue') },
			{ path: 'onlineCharge/', permission: 'menu', meta: { title: '线上服务费',disabled: true, message: '该功能已关闭，请到4.0系统使用' }, name: 'onlineCharge', component: () => System.import('../views/serviceCharge/onlineCharge/onlineCharge.vue') },
			{ path: 'onlineCharge2/', permission: 'menu', meta: { title: '线上服务费(云采链)',disabled: true, message: '该功能已关闭，请到4.0系统使用' }, name: 'onlineCharge2', component: () => System.import('../views/serviceCharge/onlineCharge2/onlineCharge.vue') },
			{ path: 'biddingExamine/', permission: 'menu', meta: { title: '中标通知书审核' }, name: 'biddingExamine(i)', component: () => System.import('../views/iframe.vue') },
			{ path: 'expertFee/', permission: 'menu', meta: { title: '专家费借支', disabled: false, message: '该功能已关闭，请到4.0系统使用' }, name: 'expertFee', component: () => System.import('../views/expertFee/expertFee.vue') },
			{ path: 'expertFeeArgu/', permission: 'menu', meta: { title: '专家费借支（其他）', disabled: false, message: '该功能已关闭，请到4.0系统使用' }, name: 'expertFeeArgu', component: () => System.import('../views/expertFeeArgu/expertFeeArgu.vue') },
			{ path: 'expertFee2', permission: 'menu', meta: { title: '专家费借支(测试)', disabled: true, message: '该功能已关闭，请到4.0系统使用' }, name: 'expertFee2', component: () => System.import('../views/expertFee2/expertFee.vue') },
			{ path: 'budgetPlan', permission: 'menu', meta: { title: '双周资金计划(测试)' }, name: 'budgetPlan', component: () => System.import('../views/expertFee2/budgetPlan.vue') },
			{ path: 'budgetPlan2', permission: 'menu', meta: { title: '双周资金计划' }, name: 'budgetPlan2', component: () => System.import('../views/expertFee2/budgetPlan2.vue') },
		]
	},
	// 提成系统
	{
		path: '/commission',
		name: 'commissionSys',
		permission: '',
		meta: { title: '提成系统' },
		icon: '', // &#xe68a
		component: main,
		children: [
			{ path: 'commissionRule/', permission: 'menu', meta: { title: '提成系统' }, name: 'commission', component: () => System.import('../views/commission/commissionSystem/commissionSystem.vue') },
			// { path: 'commissionRule/', permission: 'menu', meta: { title: '提成规则' }, name: 'commissionRule', component: () => System.import('../views/commission/commissionRule/commissionRule.vue') },
			// { path: 'commissionDeclare/', permission: 'menu', meta: { title: '提成项目申报' }, name: 'commissionDeclare', component: () => System.import('../views/commission/commissionDeclare/commissionDeclare.vue') },
			// { path: 'commissionSpecial/', permission: 'menu', meta: { title: '特殊项目申报' }, name: 'commissionSpecial', component: () => System.import('../views/commission/commissionSpecial/commissionSpecial.vue') },
			// { path: 'commissionGrant/', permission: 'menu', meta: { title: '提成发放申报' }, name: 'commissionGrant', component: () => System.import('../views/commission/commissionGrant/commissionGrant.vue') },
			// { path: 'commissionHistory/', permission: 'menu', meta: { title: '过往提成一览' }, name: 'commissionHistory', component: () => System.import('../views/commission/commissionHistory/commissionHistory.vue') },
		]
	},
	// {
	// 	path: '/commissionN',
	// 	name: 'commissionSysN',
	// 	permission: '',
	// 	meta: { title: '提成系统（旧）' },
	// 	icon: '', // &#xe68a
	// 	component: main,
	// 	children: [
	// 		{ path: 'commissionNPage/', permission: 'menu', meta: { title: '提成系统（测试）' }, name: 'commissionN', component: () => System.import('../views/commission/commissionSystem/commissionSystem.vue') },
	// 		{ path: 'commissionRule/', permission: 'menu', meta: { title: '提成规则' }, name: 'commissionRule', component: () => System.import('../views/commission/commissionRule/commissionRule.vue') },
	// 		{ path: 'commissionDeclare/', permission: 'menu', meta: { title: '提成项目申报' }, name: 'commissionDeclare', component: () => System.import('../views/commission/commissionDeclare/commissionDeclare.vue') },
	// 		{ path: 'commissionSpecial/', permission: 'menu', meta: { title: '特殊项目申报' }, name: 'commissionSpecial', component: () => System.import('../views/commission/commissionSpecial/commissionSpecial.vue') },
	// 		{ path: 'commissionGrant/', permission: 'menu', meta: { title: '提成发放申报' }, name: 'commissionGrant', component: () => System.import('../views/commission/commissionGrant/commissionGrant.vue') },
	// 		{ path: 'commissionHistory/', permission: 'menu', meta: { title: '过往提成一览' }, name: 'commissionHistory', component: () => System.import('../views/commission/commissionHistory/commissionHistory.vue') },
	// 	]
	// },
	// {
	// 	path: '/expert',
	// 	name: 'expert',
	// 	permission: '',
	// 	meta: { title: '专家管理' },
	// 	icon: '',
	// 	component: main,
	// 	children: [
	// 		{ path: 'expertList/', permission: 'menu', meta: { title: '专家库' }, name: 'expertList', component: () => System.import('../views/expert/expertsList.vue') },
	// 		{ path: 'expertExtract/', permission: 'menu', meta: { title: '专家抽取' }, name: 'expertExtract', component: () => System.import('../views/expert/expertsExtract.vue') },
	// 	]
	// },
	// 行政模块
	// {
	// 	path: '/xzmk',
	// 	name: 'xzmk(i)',
	// 	permission: '',
	// 	meta: { title: '行政模块' },
	// 	icon: '',
	// 	component: main,
	// 	children: [
	// 		{ path: 'xztz/', permission: 'Pages.ADM', meta: { title: '行政台账' }, name: 'xztz(i)', component: () => System.import('../views/iframe.vue') },
	// 		{ path: 'lpcrk/', permission: 'Pages.ADM', meta: { title: '礼品出入库' }, name: 'lpcrk(i)', component: () => System.import('../views/iframe.vue') },
	// 		{ path: 'zzqd/', permission: 'Pages.ADM', meta: { title: '证照清单' }, name: 'zzqd(i)', component: () => System.import('../views/iframe.vue') },
	// 	]
	// },
	// 人力模块
	// {
	// 	path: '/rlmk',
	// 	name: 'rlmk(i)',
	// 	permission: '',
	// 	meta: { title: '人力模块' },
	// 	icon: '',
	// 	component: main,
	// 	children: [
	// 		{ path: 'kqhzb/', permission: 'Pages.HR', meta: { title: '考勤汇总表' }, name: 'kqhzb(i)', component: () => System.import('../views/iframe.vue') },
	// 	]
	// },
	// 业务系统后台管理
	// {
	// 	path: '/ywxtManage',
	// 	name: 'ywxtManage(i)',
	// 	permission: '',
	// 	meta: { title: '业务系统后台管理' },
	// 	icon: '',
	// 	component: main,
	// 	children: [
	// 		{ path: 'tjjs/', permission: 'Pages.Report', meta: { title: '添加角色' }, name: 'tjjs(i)', component: () => System.import('../views/iframe.vue') },
	// 		{ path: 'tjyhjs/', permission: 'Pages.Report', meta: { title: '添加用户角色' }, name: 'tjyhjs(i)', component: () => System.import('../views/iframe.vue') },
	// 		{ path: 'jsyhck/', permission: 'Pages.Report', meta: { title: '角色用户查看' }, name: 'jsyhck(i)', component: () => System.import('../views/iframe.vue') },
	// 		{ path: 'fgstx/', permission: 'Pages.Report', meta: { title: '分公司通讯地址' }, name: 'fgstx(i)', component: () => System.import('../views/iframe.vue') },
	// 	]
	// },
	//交易平台管理工具
	// {
	// 	path: '/jyptManage',
	// 	name: 'jyptManage(i)',
	// 	permission: '',
	// 	meta: { title: '交易平台管理工具' },
	// 	icon: '',
	// 	component: main,
	// 	children: [
	// 		{ path: 'dzjjImport/', permission: 'menu', meta: { title: '电子竞价项目导入' }, name: 'dzjjImport(i)', component: () => System.import('../views/iframe.vue') },
	// 		{ path: 'newPlatform/', permission: 'menu', meta: { title: '新平台' }, name: 'newPlatform(i)', component: () => System.import('../views/iframe.vue') },
	// 		{ path: 'oldPlatform/', permission: 'menu', meta: { title: '旧平台' }, name: 'oldPlatform(i)', component: () => System.import('../views/iframe.vue') },
	// 		{ path: 'pbbgIllustrate/', permission: 'menu', meta: { title: '评标报告更换供应商说明' }, name: 'pbbgIllustrate(i)', component: () => System.import('../views/iframe.vue') },
	// 	]
	// },
	{
		path: '/helpCenter',
		name: 'helpCenter',
		permission: '',
		meta: { title: '帮助中心' },
		icon: '',
		component: main,
		children: [
			{ path: 'helpPage', permission: 'menu', meta: { title: '帮助中心' }, name: 'helpPage', component: () => System.import('../views/helpCenter/helpCenter.vue') },
		]
	},
	{
		path: '/surveyForm',
		name: 'surveyForm',
		permission: '',
		meta: { title: '满意度调查表' },
		icon: '',
		component: main,
		children: [
			{ path: 'surveyPage', permission: 'menu', meta: { title: '满意度调查表' }, name: 'surveyPage', component: () => System.import('../views/surveyForm/surveyForm.vue') },
		]
	},
	// 管理模块
	{
		path: '/setting',
		name: 'setting',
		permission: '', // 空权限，有子菜单时自动显示
		meta: { title: '系统管理' },
		icon: '',
		component: main,
		children: [
			{ path: 'user', permission: 'menu', meta: { title: '用户' }, name: 'user', component: () => System.import('../views/setting/user/user.vue') },
			{ path: 'role', permission: 'menu', meta: { title: '角色' }, name: 'role', component: () => System.import('../views/setting/role/role.vue') },
			{ path: 'flowRole', permission: 'menu', meta: { title: '流程角色' }, name: 'flowRole', component: () => System.import('../views/setting/role/flowRole.vue') },
			{ path: 'tenant', permission: 'menu', meta: { title: '租户' }, name: 'tenant', component: () => System.import('../views/setting/tenant/tenant.vue') },
			{ path: 'organizationUnits', permission: 'menu', meta: { title: '组织' }, name: 'organizationUnits', component: () => System.import('../views/setting/organizationUnits/organizationUnits.vue') },
			{ path: 'withdrawn', permission: 'menu', meta: { title: '离职人员' }, name: 'withdrawn(i)', component: () => System.import('../views/iframe.vue') },
			{ path: 'syncOrgUser', permission: 'menu', meta: { title: '同步' }, name: 'syncOrgUser', component: () => System.import('../views/setting/syncOrgUser.vue') },
			{ path: 'roleAssignment', permission: 'menu', meta: { title: '角色分配' }, name: 'roleAssignment', component: () => System.import('../views/setting/roleAssignment/roleAssignment.vue') },
			{ path: 'DataDict', permission: 'menu', meta: { title: '数据字典' }, name: 'DataDict', component: () => System.import('../views/setting/DataDict/DataDict.vue') },//数据字典路径
			{ path: 'permissionManage', permission:'menu', meta: { title:'菜单管理' }, name:'permissionManage',component: ()=>System.import('../views/setting/permissionManage.vue')},
			{ path: 'quickEntry', permission:'menu', meta: { title:'快速入口' }, name:'quickEntry',component: ()=>System.import('../views/setting/quickEntry/quickEntry.vue')},
			{ path: 'expenseStandards', permission:'menu', meta: { title:'专家费用标准' }, name:'expenseStandards',component: ()=>System.import('../views/setting/expenseStandards/expenseStandards.vue')},
		]
	},
	//账号管理
	{
		path: '/accountManagement',
		name: 'accountManagement',
		permission: '', // 空权限，有子菜单时自动显示
		meta: { title: '账号管理' },
		icon: '',
		component: main,
		children: [
			{ path: 'amgn', permission: 'menu', meta: { title: '账号管理' }, name: 'amgn', component: () => System.import('../views/accountManagement/accountManagement.vue') },
		]
	},
	//工作周报
	{
		path: '/workReport',
		name: 'workReport',
		permission: '', // 空权限，有子菜单时自动显示
		meta: { title: '工作周报' },
		icon: '',
		component: main,
		children: [
			{ path: 'wrt', permission: 'menu', meta: { title: '工作周报' }, name: 'wrt', component: () => System.import('../views/workReport/index.vue') },
		]
	},
	//分公司管理
	{
		path: '/branch',
		name: 'branch',
		permission: '', // 空权限，有子菜单时自动显示
		meta: { title: '分公司管理' },
		icon: '',
		component: main,
		children: [
			{ path: 'permission', permission: 'menu', meta: { title: '权限管理' }, name: 'permission', component: () => System.import('../views/branch/permissionedit.vue') },
			{ path: 'roledescription', permission: 'menu', meta: { title: '角色权限说明' }, name: 'roledescription', component: () => System.import('../views/branch/roledescription.vue') },
			{ path: 'projectManager', permission: 'menu', meta: { title: '客户经理管理' }, name: 'projectManager', component: () => System.import('../views/branch/projectManager.vue') },
		]
	},
	// {
	// 	path: '/jdData',
	// 	name: 'jdData(i)',
	// 	permission: '',
	// 	meta: { title: '集点数据' },
	// 	icon: '',
	// 	component: main,
	// 	children: [
	// 		{ path: 'jdDataReport/', permission: 'Pages.Point', meta: { title: '集点数据报表' }, name: 'jdDataReport(i)', component: () => System.import('../views/iframe.vue') },
	// 	]
	// },
	// 财务模块
	// {
	// 	path: '/cwmk',
	// 	name: 'cwmk(i)',
	// 	permission: '',
	// 	meta: { title: '财务模块' },
	// 	icon: '',
	// 	component: main,
	// 	children: [
	// 		{ path: 'bsksr/', permission: 'Pages.FD', meta: { title: '标书款收入一览表' }, name: 'bsksr(i)', component: () => System.import('../views/iframe.vue') },
	// 		{ path: 'fwfsr/', permission: 'Pages.FD', meta: { title: '服务费收入一览表' }, name: 'fwfsr(i)', component: () => System.import('../views/iframe.vue') },
	// 		{ path: 'fgsyj/', permission: 'Pages.FD', meta: { title: '各分公司业绩明细表' }, name: 'fgsyj(i)', component: () => System.import('../views/iframe.vue') },
	// 		{ path: 'fgssk/', permission: 'Pages.FD', meta: { title: '分公司开标后收款情况一览表' }, name: 'fgssk(i)', component: () => System.import('../views/iframe.vue') },
	// 		{ path: 'zbtzssk/', permission: 'Pages.FD', meta: { title: '中标通知书审核情况表' }, name: 'zbtzssk(i)', component: () => System.import('../views/iframe.vue') },
	// 	]
	// },
	// 汇总报表系统
	// {
	// 	path: '/hzbbSystem',
	// 	name: 'hzbbSystem(i)',
	// 	permission: '',
	// 	meta: { title: '汇总报表系统' },
	// 	icon: '',
	// 	component: main,
	// 	children: [
	// 		{ path: 'projectFlow/', permission: 'Pages.Gather', meta: { title: '项目流' }, name: 'projectFlow(i)', component: () => System.import('../views/iframe.vue') },
	// 		{ path: 'jtjjbb/', permission: 'Pages.Gather', meta: { title: '集团经营报表' }, name: 'jtjjbb(i)', component: () => System.import('../views/iframe.vue') },
	// 		{ path: 'jtxssr/', permission: 'Pages.Gather', meta: { title: '集团线上总收入' }, name: 'jtxssr(i)', component: () => System.import('../views/iframe.vue') },
	// 		{ path: 'zcptsj/', permission: 'Pages.Gather', meta: { title: '智采平台数据' }, name: 'zcptsj(i)', component: () => System.import('../views/iframe.vue') },
	// 		{ path: 'gyslxxx/', permission: 'Pages.Gather', meta: { title: '供应商联系信息' }, name: 'gyslxxx(i)', component: () => System.import('../views/iframe.vue') },
	// 	]
	// },
]
//手机端页面
// export const mobile = {
// 	path: '/mobile',
// 	name: 'mobile',
// 	meta: {
// 		title: 'mobile'
// 	},
// 	component: () => System.import('../views/mobile/MO_main.vue')
// };
//
export const routers = [
	loginRouter,
	signinRouter,
	forgetPwdRouter,
	locking,
	...appRouters,
	otherRouters,
	// mobile
];
